import type { FaireProductEntity } from "../../entity_types/product";

export const ramen_2: FaireProductEntity = {
  token: "ramen-2",
  type: "product",
  name: "Midnight Ramen Club Boxed Set",
  brandName: "123 farm",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/b8d11f4bfd773d9587388d07a8d7e3ae462e0e2d0fa044680f88bde37f94468f.png",
  priceDollars: 4,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/b8d11f4bfd773d9587388d07a8d7e3ae462e0e2d0fa044680f88bde37f94468f.png",
  weight: 0.5,
  dimensions: {
    width: 8,
    height: 10,
    depth: 3,
  },
  description: "Midnight ramen club boxed set with premium ingredients",
  categoryTokens: ["cat_food-snacks"],
  tags: ["ramen", "instant-ramen", "japanese-ramen", "boxed-set", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
